
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Building } from "lucide-react";

export function ManagementConsole() {
  return (
    <Card className="md:col-span-2">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Building className="h-5 w-5" />
          Management Console
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-center text-muted-foreground py-12">
          Coming soon: Edit profile details, respond to inquiries, and view analytics.
        </p>
      </CardContent>
    </Card>
  );
}
